































import Vue from 'vue';
import {humanReadableRole, UserRoleEnum} from '@/enums/userRolesEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'

export default Vue.component('roles-modal', {
  name: 'RolesModal',
  props: {
    // 'show-modal': {
    //   type: Boolean,
    //   default: false
    // },
    'user': {
      // type: { roles: [ { id: 1, name: '' } ] }
    },
  },
  data () {
    return {
      loadingData: false,
      roles: [
        { id: UserRoleEnum.MANAGER, role: humanReadableRole(UserRoleEnum.MANAGER) , isSelected: false },
        { id: UserRoleEnum.RECRUITER, role: humanReadableRole(UserRoleEnum.RECRUITER) , isSelected: false },
        { id: UserRoleEnum.SCHEDULER, role: humanReadableRole(UserRoleEnum.SCHEDULER) , isSelected: false },
        { id: UserRoleEnum.CREDENTIALER, role: humanReadableRole(UserRoleEnum.CREDENTIALER) , isSelected: false },
        { id: UserRoleEnum.ACCOUNTANT, role: humanReadableRole(UserRoleEnum.ACCOUNTANT) , isSelected: false },
        { id: UserRoleEnum.TRAVEL_LOGISTICS, role: humanReadableRole(UserRoleEnum.TRAVEL_LOGISTICS), isSelected: false },
        { id: UserRoleEnum.OWNER, role: humanReadableRole(UserRoleEnum.OWNER), isSelected: false },
        { id: UserRoleEnum.COMMUNICATIONS, role: humanReadableRole(UserRoleEnum.COMMUNICATIONS), isSelected: false },
        { id: UserRoleEnum.LICENSING, role: humanReadableRole(UserRoleEnum.LICENSING), isSelected: false }
      ]
    }
  },
  components: {
    VueSimpleSpinner
  },
  created: function () {
    this.getRoles((this.user as any).id);
  },
  methods: {
    close () {
      this.$emit('close');
    },
    getRoles (userId: number) {
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingData = true;
      }, 0);
      HTTP.get('/api/users/' + self.user.id + '/roles')
      .then(function (response) {
        let userRolesAssigned = response.data.data;
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingData = false;
        // Select the existing roles this user has
        self.roles.forEach( function (role: any) {
          userRolesAssigned.forEach(function (userRoleAssigned: any) {
            if (role.id === userRoleAssigned.roleId) {
              role.isSelected = true
            }
          })
        });
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingData = false;
        // if there was an error getting roles, close the modal and "notify" the error
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Getting Roles',
          text: 'Something went wrong getting ' + self.user.firstName + '\'s roles!',
          duration: 5000
        });
        self.close();
      })
    },
    toggleRole (role: any) {
      let self = this as any;
      HTTP.put('/api/users/' + self.user.id + '/roles', {
      	"roleId": role.id,
        "isSelected": role.isSelected
      })
      .then(function (response) {
        // If successfull, do nothing as the UI has already been updated.
      })
      .catch(function (error: any) {
        // If un-successful, change the UI to role.isSelected = !role.isSelected and display the Error Notification.
        console.error('response Error!');
        console.error(error);
        role.isSelected = !role.isSelected;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Role Update Error',
          text: 'Something went wrong updating ' + self.user.firstName + '\'s role!',
          duration: 5000
        });
      })
    },
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/cards/adminUsers/RolesModal.vue